/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateMetadata {
    getFixupPrototypeFunction() { return TemplateMetadata.fixupPrototype; }

    static newInstance(model: Partial<TemplateMetadata>): TemplateMetadata {
        let obj = Object.assign(new TemplateMetadata(), model);
        TemplateMetadata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateMetadata>): TemplateMetadata {
        if (!model) return null;
        return TemplateMetadata.newInstance(<TemplateMetadata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateMetadata) {
        if (!obj) return;

        models.TemplateMetadata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateMetadata): boolean {
        Object.setPrototypeOf(obj, TemplateMetadata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.operation_time === undefined) {
            this.operation_time = 0;
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Operational complexity/impact level (L1/L2/L3)
     */
    operation_level: models.TemplateOperationLevel;

    /**
     * Estimated operation duration. Read together with operation_level - both must be set for either to take effect
     */
    operation_time: number;

}
